export default __webpack_public_path__ + "static/media/cover.82793e32.jpeg";